import { useLanguage } from "../context/LanguageContext";
import { whatsappLink } from "../i18n/translations";
import groupImg from "../assets/img/group_beginners.mp4";
import heroImg from "../assets/img/trainer_threekids_medals.jpeg";

export const Corporate = () => {
  const { t } = useLanguage();
  const c = t.corporate;

  return (
    <div className="page page-corporate">
      <section
        className="path-hero path-hero-small"
        style={{ backgroundImage: `linear-gradient(180deg, rgba(18,18,18,0.35), rgba(18,18,18,0.85)), url(${heroImg})` }}
      >
        <div className="path-hero-inner">
          <h1>{c.heroTitle}</h1>
        </div>
      </section>

      <section className="section corporate-body">
        <p>{c.heroDesc}</p>
        <p>{c.heroDesc2}</p>
        <a className="btn btn-primary" href={whatsappLink(c.ctaMessage)} target="_blank" rel="noreferrer">
          {c.cta}
        </a>
      </section>

      <section className="section corporate-video">
        <video controls muted className="corporate-video-el">
          <source src={groupImg} type="video/mp4" />
        </video>
      </section>
    </div>
  );
};
